// 보행 그래프(캠퍼스 도보 경로)의 draft→검증→청크 분할→배포→롤백 스키마.
// FAQ/홈/셔틀의 cmsContent 패턴과 물리 구조가 다르다(청크 분할 필요) — 별도 컬렉션
// campusGraphContent/*를 쓴다(firestore.rules, src/services/campusGraphCmsService.js,
// apps/admin/src/lib/campusGraphCms.js 참고).

export const CAMPUS_GRAPH_SCHEMA_VERSION = 'campusGraph.v1'

// Firestore 문서 크기 상한(1MiB)보다 넉넉히 낮게 잡은 청크당 바이트 예산.
export const CAMPUS_GRAPH_CHUNK_BYTE_BUDGET = 700_000

export const EMPTY_CAMPUS_GRAPH_DATA = {
  schemaVersion: CAMPUS_GRAPH_SCHEMA_VERSION,
  nodes: [],
  edges: [],
  buildingEntranceNodeMap: {},
}

export const EMPTY_CAMPUS_GRAPH_NODE = { id: '', label: '', lat: '', lng: '' }
export const EMPTY_CAMPUS_GRAPH_EDGE = { id: '', from: '', to: '' }
